import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import FocusableButton from 'components/common/FocusableButton';
import React from 'react';
import DAY_ZONE_TYPES from 'constants/DAY_ZONE_TYPES';
import GLOCOSE_COLUMNS from 'constants/GLOCOSE_COLUMNS';
import CHECK_COLORS from 'constants/CHECK_COLORS';

export default function GlocoseAnalysisTable(props) {
  const {
    selectedIndex,
    highlightIndex,
    optionsRef,
    chartRef,
    selectedIndiceRef,
    hightlightIndiceRef,
    selectedColorRef,
    highlightColorRef,
    backgroundColorRef,
    setSelectedIndex,
    setHighlightIndex,
    hash,
  } = props;

  const onHighlight = React.useCallback((index, active) => (e) => {
    if (active) {
      if (index in selectedIndiceRef.current) return;
      // optionsRef.current.data.datasets[0].backgroundColor[index] = highlightColorRef.current;
      // chartRef.current.update();
      setHighlightIndex(() => index);
      hightlightIndiceRef.current[index] = true;
    } else {
      Object.keys(hightlightIndiceRef.current).forEach(index => {
        if (index in selectedIndiceRef.current) return;
        // optionsRef.current.data.datasets[0].backgroundColor[index] = backgroundColorRef.current;
        delete hightlightIndiceRef.current[index];
      });
      // chartRef.current.update();
      setHighlightIndex(() => null);
    }
  }, []);

  const onColumnSelect = React.useCallback((index) => (e) => {
    if (!(index in selectedIndiceRef.current)) {
      Object.keys(selectedIndiceRef.current).forEach(index => {
        // optionsRef.current.data.datasets[0].backgroundColor[index] = backgroundColorRef.current;
        delete selectedIndiceRef.current[index];
      });
      // optionsRef.current.data.datasets[0].backgroundColor[index] = selectedColorRef.current;
      selectedIndiceRef.current[index] = true;
    } else {
      Object.keys(selectedIndiceRef.current).forEach(index => {
        // optionsRef.current.data.datasets[0].backgroundColor[index] = backgroundColorRef.current;
        delete selectedIndiceRef.current[index];
      });
    }

    // chartRef.current.update();
    setSelectedIndex((i) => i === index ? 0 : index);
    // chartRef.current.update();
  }, []);

  return (
    <table>
      <thead>
        <tr>
          <th>
            <div>
              <FocusableButton>
                {T('구분')}
              </FocusableButton>
            </div>
          </th>
          {GLOCOSE_COLUMNS.map((name, index) => {
            const triggered = index === highlightIndex;
            const selected = index === selectedIndex;
            const unselectable = DAY_ZONE_TYPES.includes(name);
            return (
              <th key={index}>
                <div>
                  <FocusableButton
                    {...ex(['TableButton', { triggered, selected }], {
                      onMouseEnter: onHighlight(index, true),
                      onMouseLeave: onHighlight(index, false),
                      ...(unselectable ? {} : { onClick: onColumnSelect(index) }),
                    })}
                  >
                    {name}
                  </FocusableButton>
                </div>
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div>
              TAR
            </div>
          </td>
          {GLOCOSE_COLUMNS.map((name, index) => (
            <td key={index}>
              <div {...ex(['BASE_COLOR', CHECK_COLORS('TAR', hash[name]?.tar), { triggered: index === highlightIndex, selected: index === selectedIndex }])}>
                {hash[name]?.tar}
              </div>
            </td>
          ))}
        </tr>
        <tr>
          <td>
            <div>
              TIR
            </div>
          </td>
          {GLOCOSE_COLUMNS.map((name, index) => (
            <td key={index}>
              <div {...ex(['BASE_COLOR', CHECK_COLORS('TIR', hash[name]?.tir), { triggered: index === highlightIndex, selected: index === selectedIndex }])}>
                {hash[name]?.tir}
              </div>
            </td>
          ))}
        </tr>
        <tr>
          <td>
            <div>
              TBR
            </div>
          </td>
          {GLOCOSE_COLUMNS.map((name, index) => (
            <td key={index}>
              <div {...ex(['BASE_COLOR', CHECK_COLORS('TBR', hash[name]?.tbr), { triggered: index === highlightIndex, selected: index === selectedIndex }])}>
                {hash[name]?.tbr}
              </div>
            </td>
          ))}
        </tr>
        <tr>
          <td>
            <div>
              GMI
            </div>
          </td>
          {GLOCOSE_COLUMNS.map((name, index) => (
            <td key={index}>
              <div {...ex(['BASE_COLOR', CHECK_COLORS('GMI', hash[name]?.gmi), { triggered: index === highlightIndex, selected: index === selectedIndex }])}>
                {hash[name]?.gmi}
              </div>
            </td>
          ))}
        </tr>
        <tr>
          <td>
            <div>
              CV
            </div>
          </td>
          {GLOCOSE_COLUMNS.map((name, index) => (
            <td key={index}>
              <div {...ex(['BASE_COLOR', CHECK_COLORS('CV', hash[name]?.cv), { triggered: index === highlightIndex, selected: index === selectedIndex }])}>
                {hash[name]?.cv}
              </div>
            </td>
          ))}
        </tr>
        <tr>
          <td>
            <div>
              평균혈당
            </div>
          </td>
          {GLOCOSE_COLUMNS.map((name, index) => (
            <td key={index}>
              <div {...ex(['BASE_COLOR', CHECK_COLORS('B', hash[name]?.avg_bld_sugr), { triggered: index === highlightIndex, selected: index === selectedIndex }])}>
                {hash[name]?.avg_bld_sugr}
              </div>
            </td>
          ))}
        </tr>
        <tr>
          <td>
            <div>
              최고혈당
            </div>
          </td>
          {GLOCOSE_COLUMNS.map((name, index) => (
            <td key={index}>
              <div {...ex(['BASE_COLOR', CHECK_COLORS('B', hash[name]?.high_bld_sugr), { triggered: index === highlightIndex, selected: index === selectedIndex }])}>
                {hash[name]?.high_bld_sugr}
              </div>
            </td>
          ))}
        </tr>
        <tr>
          <td>
            <div>
              최저혈당
            </div>
          </td>
          {GLOCOSE_COLUMNS.map((name, index) => (
            <td key={index}>
              <div {...ex(['BASE_COLOR', CHECK_COLORS('B', hash[name]?.low_bld_sugr), { triggered: index === highlightIndex, selected: index === selectedIndex }])}>
                {hash[name]?.low_bld_sugr}
              </div>
            </td>
          ))}
        </tr>

      </tbody>
    </table>
  );
}
